import { BlocksContent } from '@strapi/blocks-react-renderer';

export const extractPlainTextFromBlocksContent = (content: BlocksContent): string => {
	if (!content || !Array.isArray(content)) return '';

	return content
		.map(block => {
			if (!block.children) return '';

			return block.children
				.map((child: any) => {
					if (child.type === 'text') return child.text || '';
					return '';
				})
				.join('');
		})
		.join(' ')
		.replace(/\s+/g, ' ')
		.trim();
};

const ALT_TEXT_MAX_LENGTH = 125;

// Short alt text from a rich-text title: plain text, trimmed to a screen-reader-friendly length.
export const blocksContentToAltText = (content?: BlocksContent | null): string => {
	const text = content ? extractPlainTextFromBlocksContent(content) : '';
	if (text.length <= ALT_TEXT_MAX_LENGTH) return text;

	return `${text.slice(0, ALT_TEXT_MAX_LENGTH).trimEnd()}…`;
};

export const toBlocksContent = (text: string): BlocksContent => [
	{
		type: 'paragraph',
		children: [{ type: 'text', text }]
	}
];

const TOKEN_PATTERN = /\{(\w+)\}/g;

const interpolateNode = (node: any, vars: Record<string, string | number>): any => {
	if (Array.isArray(node)) return node.map(child => interpolateNode(child, vars));

	if (!node || typeof node !== 'object') return node;

	const next = { ...node };

	if (typeof next.text === 'string')
		next.text = next.text.replace(TOKEN_PATTERN, (match: string, key: string) =>
			key in vars ? String(vars[key]) : match
		);

	if (Array.isArray(next.children)) next.children = interpolateNode(next.children, vars);

	return next;
};

export const interpolateBlocks = (
	content: BlocksContent | null | undefined,
	vars: Record<string, string | number>
): BlocksContent | null => {
	if (!content || !Array.isArray(content)) return null;

	return interpolateNode(content, vars) as BlocksContent;
};
